import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class FarmersRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    brokerId: number;
    constructor(brokerId:number){
        this.brokerId = brokerId;
    }
}